(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('newref', {
      restrict: 'E',
      bindings: {
        consultid: '<?',
        patientid: '<?',
        mode: '@?',
        modal: '<?'
      },
      templateUrl: 'vcpatdocs/newref-smartcomponent.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper','$window',
        function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper, $window) {
          let vm = this;
          vm.saveDoctor = saveDoctor;
          vm.clearDoctor = clearDoctor;

          vm.savePatient = savePatient;
          vm.clearPatient = clearPatient;

          vm.saveLabvalues = saveLabvalues;
          vm.saveImagingvalues = saveImagingvalues;
          vm.setRefDate = setRefDate;
          vm.setDiag = setDiag;

          vm.add = add;
          vm.cancel = cancel;
          vm.print = print;
          vm.preview = preview;

          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};


          vm.$onInit = function () {
            vm.mode = 'patient';
            initNewRef();

            vm.labreset = 0;
            vm.imagingreset = 0;

            vm.standalone = angular.isUndefined(vm.patientid) && angular.isUndefined(vm.consultid);

            // determine client mode
            if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
              vm.kunde = 'Patient';
              vm.testkunde = 'Testpatient';
            } else {
              vm.mode = 'client';
              vm.kunde = 'Kunde';
              vm.testkunde = 'Testkunde';
            }


            //  get labvalues and groups from config
            Config.$find('labconfiguration').$then(labconfig => {
              vm.labgroups = labconfig.groups;
              vm.labvalues = labconfig.values;
            }, error => {
              $log.error(error);
              Rlog.error('patdocs', 'newref', 'labconfiguration.$find() failed', {id: vm.patientid});
            });


          }; // $onInit()


          // vm.patientid, consultid might be late propagating, get them on first real change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.patientid) && angular.isString(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
                vm.patientid = changes.patientid.currentValue;
                // get client/patient information for inclusion inside document
                ClientHelper.find(vm.mode, vm.patientid).$then(function (patient) {
                  vm.patient = patient;
                  vm.newref.patient = {};
                  vm.newref.patient.svdata = vm.patient.svdata;
                  vm.diagnoses = vm.patient.flatdiagnoses.map((d) => {return {text: d, use: false}});
                  vm.newref.patientid = vm.patient._id;
                  vm.newref.patient._id = vm.patient._id;
                  vm.newref.patient.primarycontact = vm.patient.primarycontact;
                }, function (err) {
                  $log.error('patient not found, id: ', vm.patientid, err);
                  Rlog.error('patdocs', 'newref', 'client.$find() failed', {id: vm.patientid});
                });
              }
              if (angular.isDefined(changes.consultid)) {
                vm.consultid = changes.consultid.currentValue;
                if (angular.isUndefined(vm.newref)) {
                  initNewRef();
                } else {
                  vm.newref.consultid = vm.consultid;
                }
              }
            }
          };


          // reset ref form
          function initNewRef() {
            vm.newref = {};
            vm.newref.type = 'referral';
            vm.newref.refdate = '';
            vm.newref.ginclude = [];
            vm.newref.additionalvalues = [];
            if (angular.isDefined(vm.consultid)) {
              vm.newref.consultid = vm.consultid;
            }
            if (angular.isDefined(vm.patient)) {
              vm.newref.patient = {};
              vm.newref.patient.svdata = vm.patient.svdata;
              vm.newref.patientid = vm.patient._id;
              vm.newref.patient._id = vm.patient._id;
              vm.newref.patient.primarycontact = vm.patient.primarycontact;
            }
          }

          // save referral doctor
          function saveDoctor(doctor) {
            delete vm.newref.to;
            vm.newref.doctor = doctor;
          }

          // clear referral doctor
          function clearDoctor() {
            delete vm.newref.doctor;
          }

          // save referral labvalues
          function saveLabvalues(allvalues, ginclude, additionalvalues, cleangroups) {
            vm.newref.labvalues = allvalues;
            vm.newref.ginclude = ginclude;
            vm.newref.additionalvalues = additionalvalues;
            vm.newref.cleangroups = cleangroups;

          }

          // save referral imagevalues
          function saveImagingvalues(allvalues, ginclude, additionalvalues) {
            vm.newref.imagingvalues = allvalues;
            vm.newref.ginclude = ginclude;
            vm.newref.additionalvalues = additionalvalues;

          }

          function setRefDate() {
            vm.newref.refdate = moment().locale('de-at').format('ll');
          }

          function setDiag() {
            let tmp = vm.diagnoses.filter((d) => {if (d.use) return d;}).map((d) => {return d.text;})
            vm.newref.diag = tmp.join(', ');
          }

          // save patient data
          function savePatient(client, mode) {
            $log.debug('patient in savePAtient: ', client, mode);
            delete vm.newref.patient;
            vm.patient = client;
            vm.patientid = client._id;
            vm.newref.patient = {};
            vm.newref.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
            vm.newref.patient.svdata = vm.patient.svdata;
            vm.newref.patientid = vm.patient._id;
            vm.newref.patient._id = vm.patient._id;
            vm.newref.patient.primarycontact = vm.patient.primarycontact;
          }

          // clear patient
          function clearPatient() {
            delete vm.newref.patient;
            delete vm.newref.patientid;
          }


          function add() {
            Patdocs.$create(vm.newref).$then(function () {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              initNewRef();
              delete vm.newref.reftype;
              vm.imagingreset++;
              vm.labreset++;
              $timeout(function () {
                vm.saved = false;
                if (angular.isDefined(vm.modal)) {
                  vm.modal.close();
                }
              }, 2000);
            }, (err => {
              vm.savefailed = true;
              $log.error('adding single referral failed: ', err);
              $timeout(function () {
                vm.savefailed = false;
              }, 3000);
            }));
          }

          function cancel() {
            vm.saved = false;
            vm.canceled = true;
            vm.savefailed = false;
            initNewRef();
            vm.labreset++;
            vm.imagingreset++;
            $timeout(function () {
              vm.canceled = false;
              if (angular.isDefined(vm.modal)) {
                vm.modal.close();
              }
            }, 1500);
          }

          function print() {
            Patdocs.$create(vm.newref).$then(function (referral) {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              $timeout(function () {
                vm.saved = false;
              }, 3000);
              initNewRef();
              $log.debug('referral returned: ', referral);
              PrintHelper.referralSinglePrint(referral._id, vm.patientid).then(function () {
                $log.debug('printing single erferral succeeded');
                vm.printed = true;
                $timeout(function () {
                  delete vm.printed;
                }, 3000);
              }, function (err) {
                vm.printed = false;
                $timeout(function () {
                  delete vm.printed;
                }, 3000);
                $log.error('printing single referral failed: ', err);
              });

            });
          }

          function preview() {
            Patdocs.$create(vm.newref).$then(function (referral) {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              $timeout(function () {
                vm.saved = false;
              }, 3000);
              initNewRef();
              $log.debug('referral returned: ', referral);
              PrintHelper.referralSinglePreview(referral._id, vm.patientid).then(function (url) {
                $log.debug('previewing single referral succeeded: ', url);
                vm.previewurl = url.data;
                vm.previewed = true;
                $window.open(url);
                $timeout(function () {
                  delete vm.previewed;
                }, 3000);
              }, function (err) {
                vm.previewed = false;
                $timeout(function () {
                  delete vm.previewed;
                }, 3000);
                $log.error('previewing single referral failed: ', err);
              });

            });
          }

        }
      ] // controller
    }); // component

// klammerfriedhof
}());
